import type { JSX } from 'react'

import { ButtonFonts, IconPositions } from "/app/libraries/arcana/src/atoms/Button/index.ts"
import { ButtonGroup } from "/app/libraries/arcana/src/blocks/ButtonGroup/index.ts"
import { FIXED_INDENTS } from "/app/libraries/arcana/src/vars/index.ts"
import { IconNames } from "/app/libraries/arcana/src/atoms/Icon/index.ts"
import { PrimaryButtonWithoutGradient, PrimaryOpacityFontButton1Button, SecondaryOpacityFontButton1Button } from "/app/libraries/arcana/src/atoms/Button/Templates/index.ts"

import { useUnit } from 'effector-react'
import { useTranslation } from 'react-i18next'
import {
  $getToaLoading,
  $lockedAccepting,
  $lockedDeclining,
  $toa,
  $wasLoadingError,
  acceptToa,
  acceptToaFx,
  declineToa,
  error,
  getToa,
  signOutFx,
} from '../model'

Buttons.displayName = 'Buttons'
export function Buttons(): JSX.Element | null {
  const { t } = useTranslation()

  const {
    toa,
    err,
    wasLoadingError,
    getToaLoading,
    lockedAccepting,
    lockedDeclining,
    pendingAccept,
    pendingDecline,
    getToaEvent,
    declineToaEvent,
    acceptToaEvent,
  } = useUnit({
    toa: $toa,
    err: error.$loading,
    wasLoadingError: $wasLoadingError,
    getToaLoading: $getToaLoading,
    lockedAccepting: $lockedAccepting,
    lockedDeclining: $lockedDeclining,
    pendingAccept: acceptToaFx.pending,
    pendingDecline: signOutFx.pending,
    getToaEvent: getToa,
    declineToaEvent: declineToa,
    acceptToaEvent: acceptToa,
  })

  const pending = pendingAccept || pendingDecline
  const locked = lockedAccepting || lockedDeclining

  return (
    <ButtonGroup>
      {wasLoadingError || err ? (
        <>
          <PrimaryOpacityFontButton1Button
            title={t('retry')}
            key='button3'
            icon={IconNames.restart}
            iconPosition={IconPositions.Left}
            withLoader
            isLoading={getToaLoading}
            disabled={getToaLoading}
            onClick={() => getToaEvent()}
            font={ButtonFonts.FontSmBold}
          />
          <SecondaryOpacityFontButton1Button
            title={t('back')}
            disabled={pendingDecline || lockedDeclining}
            key='button4'
            withLoader
            isLoading={pendingDecline || lockedDeclining}
            onClick={() => declineToaEvent()}
            font={ButtonFonts.FontSmBold}
          />
        </>
      ) : (
        <>
          <PrimaryButtonWithoutGradient
            key='button1'
            title={t('accept')}
            disabled={!toa || pending || locked}
            paddings={[FIXED_INDENTS.INDENT_30, FIXED_INDENTS.INDENT_100]}
            withLoader
            isLoading={pendingAccept || lockedAccepting}
            onClick={() => acceptToaEvent()}
            font={ButtonFonts.FontSmBold}
          />
          {toa?.buttonType === 'OK_CANCEL' && (
            <SecondaryOpacityFontButton1Button
              title={t('cancel')}
              disabled={!toa || pending || locked}
              key='button2'
              withLoader
              isLoading={pendingDecline || lockedDeclining}
              onClick={() => declineToaEvent()}
              font={ButtonFonts.FontSmBold}
            />
          )}
        </>
      )}
    </ButtonGroup>
  )
}
